<template>
  <v-layout>
    <v-flex offset-md2 md8>
      <v-card>
    <v-card-title>
      <v-list-item-title class="headline mb-1">Cuadre de Caja</v-list-item-title>
    </v-card-title>
    <v-card-text>
      <v-flex>
        <v-text-field label="Total del Cheque" v-model="vcheque"></v-text-field>
      </v-flex>
      <v-flex pt-100>
        <v-text-field label="Billetes de 200" v-model="v200"></v-text-field>
      </v-flex>
      <v-flex pt-100>
        <v-text-field label="Billetes de 100" v-model="v100"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Billetes de 50" v-model="v50"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Billetes de 20" v-model="v20"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Billetes de 10" v-model="v10"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Billetes de 5" v-model="v5"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Billetes de 1" v-model="v1"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Monedas de 1" v-model="m1"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Monedas de 0.50" v-model="v050"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Monedas de 0.25" v-model="v025"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Monedas de 0.10" v-model="v010"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Monedas de 0.05" v-model="v005"></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Recibo" v-model="recibo"></v-text-field>
      </v-flex>
      <v-layout>
        <v-flex>
        <v-text-field label="No. Boleta 1"  v-model="boleta_n1"></v-text-field>
      </v-flex>
      <v-flex>
          <v-text-field label="Boleta 1" v-model="boleta1">
        </v-text-field>
      </v-flex>
      <v-flex>
         <v-select
                v-bind:items="bancos"
                v-model="banco"
                itemText="nombre"
                label="banco"
                single-line
                bottom
              >
              </v-select>
      </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
        <v-text-field label="No. Boleta 2" v-model="boleta_n2"></v-text-field>
      </v-flex>
      <v-flex>
          <v-text-field label="Boleta 2" v-model="boleta2">
        </v-text-field>
      </v-flex>
      <v-flex>
         <v-select
                v-bind:items="bancos"
                v-model="banco2"
                itemText="nombre"
                label="banco2"
                single-line
                bottom
              >
              </v-select>
      </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
        <v-text-field label="No. Boleta 3" v-model="boleta_n3"></v-text-field>
      </v-flex>
      <v-flex>
          <v-text-field label="Boleta 3" v-model="boleta3">
        </v-text-field>
      </v-flex>
      <v-flex>
         <v-select
                v-bind:items="bancos"
                v-model="banco3"
                itemText="nombre"
                label="banco3"
                single-line
                bottom
              >
              </v-select>
      </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
        <v-text-field label="Suma Total" v-model="total" disabled></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field label="Total a Entregar" v-model="caja.total" disabled></v-text-field>
      </v-flex>
        <v-flex>
        <v-text-field label="Diferencia" v-model="diferencia" disabled></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn  class="blue--text text--darken-2" @click="editarcaja" :disabled="cuadrado">
                    Guardar
        </v-btn>
      </v-flex>
      </v-layout>

    </v-card-text>
    </v-card>
    </v-flex>
    <v-flex>
    </v-flex>
  </v-layout>

</template>

<script>
  import {
    caja
  } from '../plugins/urlsbackend'
  export default {
    created () {
      this.$store.dispatch('getbancos')
      this.$store.dispatch('requestcaja')
    },
    data () {
      return {
        vcheque: '',
        boleta1: 0,
        boleta2: 0,
        boleta3: 0,
        boleta_n1: '',
        boleta_n2: '',
        boleta_n3: '',
        v100: '',
        v200: '',
        v50: '',
        v20: '',
        v10: '',
        v5: '',
        v1: '',
        v050: '',
        v025: '',
        v010: '',
        v005: '',
        m1: '',
        recibo: '',
        banco: {},
        banco2: {},
        banco3: {}
      }
    },
    computed: {
      bancos: function () {
        return this.$store.getters.bancos
      },
      banco: {
        get: function () {
          return this.$store.getters.getbanco
        },
        set: function (dato) {
          this.$store.commit('actualizarbanco', dato)
        }
      },
      banco2: {
        get: function () {
          return this.$store.getters.getbanco2
        },
        set: function (dato) {
          this.$store.commit('actualizarbanco2', dato)
        }
      },
      banco3: {
        get: function () {
          return this.$store.getters.getbanco3
        },
        set: function (dato) {
          this.$store.commit('actualizarbanco3', dato)
        }
      },
      total: function () {
        let cheque = this.vcheque !== '' ? this.vcheque : 0
        let boleta1 = this.boleta1 !== '' ? this.boleta1 : 0
        let boleta2 = this.boleta2 !== '' ? this.boleta2 : 0
        let boleta3 = this.boleta3 !== '' ? this.boleta3 : 0
        let vd100 = this.v100 !== '' ? this.v100 : 0
        let vd200 = this.v200 !== '' ? this.v200 : 0
        let vd50 = this.v50 !== '' ? this.v50 : 0
        let vd20 = this.v20 !== '' ? this.v20 : 0
        let vd10 = this.v10 !== '' ? this.v10 : 0
        let vd5 = this.v5 !== '' ? this.v5 : 0
        let vd1 = this.v1 !== '' ? this.v1 : 0
        let md1 = this.m1 !== '' ? this.m1 : 0
        let vd050 = this.v050 !== '' ? this.v050 : 0
        let vd025 = this.v025 !== '' ? this.v025 : 0
        let vd010 = this.v010 !== '' ? this.v010 : 0
        let vd005 = this.v005 !== '' ? this.v005 : 0
        let recibo = this.recibo !== '' ? this.recibo : 0
        return (parseInt(cheque) + parseFloat(boleta1) + parseFloat(boleta2) + parseFloat(recibo) + parseFloat(boleta3) + parseInt(vd100) * 100 + parseInt(vd200) * 200 +
          parseInt(vd50) * 50 + parseInt(vd20) * 20 + parseInt(vd10) * 10 + parseInt(vd5) * 5 +
          parseInt(vd1) * 1 + parseInt(md1) * 1 + parseFloat(vd050) * 0.50 + parseFloat(vd025) * 0.25 +
          parseFloat(vd010) * 0.10 +
          parseFloat(vd005) * 0.05).toFixed(2)
      },
      caja: function () {
        console.log(this.$store.getters.getCaja)
        return this.$store.getters.getCaja[0]
      },
      diferencia: function () {
        return (this.caja.total - this.total).toFixed(2)
      },
      cuadrado: function () {
        if (this.diferencia > 0) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      editarcaja () {
        let sencillo = parseFloat(this.caja.sencillo)
        let cheque = this.vcheque !== '' ? this.vcheque : 0
        let boleta1 = this.boleta1 !== '' ? this.boleta1 : 0
        let boleta2 = this.boleta2 !== '' ? this.boleta2 : 0
        let boleta3 = this.boleta3 !== '' ? this.boleta3 : 0
        let vd100 = this.v100 !== '' ? this.v100 : 0
        let vd200 = this.v200 !== '' ? this.v200 : 0
        let vd50 = this.v50 !== '' ? this.v50 : 0
        let vd20 = this.v20 !== '' ? this.v20 : 0
        let vd10 = this.v10 !== '' ? this.v10 : 0
        let vd5 = this.v5 !== '' ? this.v5 : 0
        let vd1 = this.v1 !== '' ? this.v1 : 0
        let md1 = this.m1 !== '' ? this.m1 : 0
        let vd050 = this.v050 !== '' ? this.v050 : 0
        let vd025 = this.v025 !== '' ? this.v025 : 0
        let vd010 = this.v010 !== '' ? this.v010 : 0
        let vd005 = this.v005 !== '' ? this.v005 : 0
        let recibo = this.recibo !== '' ? this.recibo : 0
        let data = {
          'boleta1': boleta1,
          'boleta2': boleta2,
          'boleta3': boleta3,
          'boleta_n1': this.boleta_n1,
          'boleta_n2': this.boleta_n2,
          'boleta_n3': this.boleta_n3,
          'cheque': cheque,
          'b200': vd200,
          'b100': vd100,
          'b50': vd50,
          'b20': vd20,
          'b10': vd10,
          'b5': vd5,
          'b1': vd1,
          'md1': md1,
          'm50': vd050,
          'm25': vd025,
          'm10': vd010,
          'm5': vd005,
          'recibo': recibo,
          'entrega': parseFloat(this.total + sencillo).toFixed(2),
          'banco_boleta1': this.banco.id,
          'banco_boleta2': this.banco2.id,
          'banco_boleta3': this.banco3.id
        }
        this.$http.put(caja + this.caja.id + '/', data,
          {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}},
        ).then((data) => {
          alert('Cuadrado exitosamente')
          window.reload()
        }, function (response) {
          alert('Ocurrio un erro no se pudo guardar')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Cuadrar.vue?47924cae